export const colorClasses: Record<string, Record<string, string>> = {
	primary: {
		red: "text-lightRed bg-secondaryRed hover:bg-darkRed",
		blue: "text-primaryBlue bg-lightBlue hover:bg-secondaryBlue",
		green: "text-primaryGreen bg-lightGreen hover:bg-secondaryGreen",
		gray: "text-primaryGray bg-lightGray hover:bg-darkGray",
		yellow: "text-orange-600 bg-orange-100 hover:bg-orange-200",

		roseWhite: "text-lightRoseWhite bg-secondaryRoseWhite hover:bg-darkRoseWhite",
		purple: "text-lightPurple bg-secondaryPurple hover:bg-darkPurple",
		violet: "text-lightViolet bg-secondaryViolet hover:bg-darkViolet",
		mutedViolet: "text-lightMutedViolet bg-secondaryMutedViolet hover:bg-darkMutedViolet",
		facebook: "text-white bg-[#1877F2] hover:bg-[#0d65d9]",
		instagram: "text-white bg-[#E1306C] hover:bg-[#C13584]",
		default: "text-white bg-primaryPurple hover:bg-darkPurple",
	},
	secondary: {
		red: "text-darkRed bg-lightRed hover:bg-secondaryRed",
		blue: "text-white bg-primaryBlue hover:bg-secondaryBlue",
		green: "text-white bg-darkGreen hover:bg-primaryGreen",
		gray: "text-darkGray bg-lightGray hover:bg-primaryGray",
		orange: "text-white bg-orange-500 hover:bg-orange-700",
		yellow: "text-white bg-yellow-500 hover:bg-yellow-400",

		roseWhite: "text-darkRoseWhite bg-lightRoseWhite hover:bg-primaryRoseWhite",
		purple: "text-darkPurple bg-lightPurple hover:bg-primaryPurple",
		violet: "text-darkViolet bg-lightViolet hover:bg-primaryViolet",
		mutedViolet: "text-darkMutedViolet bg-lightMutedViolet hover:bg-primaryMutedViolet",
		facebook: "text-[#0d65d9] bg-[#DCE8FF] hover:bg-[#bdd5ff]",
		instagram: "text-[#C13584] bg-[#FDD6E3] hover:bg-[#FAB8CF]",
		default: "text-darkPurple bg-lightPurple hover:bg-primaryPurple",
	},
};
